import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from "tss-react/mui";
import classNames from 'classnames';
import AuthChooserButton from '../AuthChooserButton';
import styles from './styles';

function DualActionButtonPanel(props) {

    const { classes } = props;
    const panelClass = classNames(classes.panel, classes.panelBottom);

    const leftButtonDisabled = Boolean(props.leftButtonDisabled);
    const rightButtonDisabled = Boolean(props.rightButtonDisabled);

    return (
        <div className={panelClass}>
            <AuthChooserButton
                preventPositioning={true}
                icon={props.leftIcon}
                text={props.leftActionText}
                className={classes.leftButton}
                currentContext={props.leftContext}
                disabled={leftButtonDisabled}
                forgottenCardClicked={props.forgottenCardClicked}
                qrScannerClicked={props.qrScannerClicked}
                qrCodeClicked={props.qrCodeClicked} />

            <AuthChooserButton
                preventPositioning={true}
                icon={props.rightIcon}
                text={props.rightActionText}
                className={classes.rightButton}
                disabled={rightButtonDisabled}
                currentContext={props.rightContext}
                forgottenCardClicked={props.forgottenCardClicked}
                qrScannerClicked={props.qrScannerClicked}
                qrCodeClicked={props.qrCodeClicked} />
        </div>
    );
}

DualActionButtonPanel.propTypes = {

    leftActionText: PropTypes.string.isRequired,
    rightActionText: PropTypes.string.isRequired,

    rightIcon: PropTypes.func,
    leftIcon: PropTypes.func,

    rightContext: PropTypes.string,
    leftContext: PropTypes.string,

    leftButtonEnabled: PropTypes.bool,
    rightButtonEnabled: PropTypes.bool,

    forgottenCardClicked: PropTypes.func,
    qrCodeClicked: PropTypes.func,
    qrScannerClicked: PropTypes.func
};

export default withStyles(DualActionButtonPanel,styles);